export const ageGroups = [
  {
    key: 'TEEN',
    value: '18-20 yrs',
  },
  { key: 'ADULT', value: '21+ yrs' },
]

export const collegeYears = [
  {
    label: '1<sup>st</sup>',
    value: 1,
  },
  {
    label: '2<sup>nd</sup>',
    value: 2,
  },
  {
    label: '3<sup>rd</sup>',
    value: 3,
  },
  {
    label: '4<sup>th</sup>',
    value: 4,
  },
]

// export const platformOptions = [
//   {
//     label: 'TV',
//     value: 'TV',
//   },
//   {
//     label: 'YouTube',
//     value: 'YOUTUBE',
//   },
//   {
//     label: 'OTTs - Netflix, Prime, Hotstar, etc',
//     value: 'OTTS',
//   },
//   {
//     label: 'Social Platforms: Meta, Instagram, etc',
//     value: 'SOCIAL_PLATFORMS',
//   },
// ]

export const genderOptions = [
  {
    label: 'Male',
    value: 'M',
  },
  {
    label: 'Female',
    value: 'F',
  },
]
